// §25.4 / §9.1 — Cascade as an in-process app.
//
// A **factory**, not a constant, because Cascade holds a D-059 capability: `HangarAPI` carries no
// settings surface (§4.1) and Cascade needs two §14 numbers. `App.tsx` grants it at composition,
// the same way Settings, Photos and the Terminal receive theirs — so an external app can never
// obtain one and the grant is a single readable line in the shell.
//
// Manifest only (D-247): the engine, the view, the palette and the CSS live behind the `import()`.
import type { ArcadeShellAccess, InProcessApp } from '@hangar/shared';
import { createLazyApp } from '@/gamekit/lazy';

export function createCascadeApp(access: ArcadeShellAccess): InProcessApp {
  return createLazyApp<{ access: ArcadeShellAccess }>({
    app: {
      id: 'cascade',
      name: 'Cascade',
      icon: { glyph: 'boxes', hue: 265 },
      keywords: ['blocks', 'stack', 'lines', 'tetromino', 'game', 'arcade'],
      category: 'Arcade',
      // §29.1 (D-369) — the sub-group header this title sits under in the launcher and the Store.
      group: 'Action',
      requiresAuth: true,
      // Fixed aspect, letterboxed by the host (D-229): a free-resizing well would change how much
      // of the board a player can see, which here is a competitive difference.
      window: { width: 720, height: 620, minWidth: 520, minHeight: 460, multiWindow: false },
      jumpList: [
        { id: 'marathon', label: 'Marathon' },
        { id: 'sprint', label: 'Sprint' },
      ],
    },
    load: () => import('./Cascade'),
    props: { access },
  });
}
